import styled from 'styled-components';
import { lineHeight } from '@whitelabel/helpers/style/type';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';

const StyledPrimaryTitle = styled.h1`
  line-height: ${lineHeight('headingsLg')};
  margin-inline-end: 0.5rem;
  margin-inline-start: 0.5rem;

  ${mediaBreakpointUp('md')`
    margin-inline-end: 1rem;
    margin-inline-start: 1rem;
  `}

  > span {
    background: ${themeColor('primary')};
    box-shadow: 0.5rem 0 0 ${themeColor('primary')}, -0.5rem 0 0 ${themeColor('primary')};

    ${mediaBreakpointUp('md')`
    box-shadow: 1rem 0 0 ${themeColor('primary')}, -1rem 0 0 ${themeColor('primary')};
  `};
  }
`;

export default StyledPrimaryTitle;
